/**
 * Suggested firm categories surfaced in the welcome-analyzer questionnaire.
 * The user is free to type anything; these are just the common starting
 * points. Real-estate categories lead the list since Clai's primary
 * audience runs real-estate transactions; the rest cover the most common
 * SMB industries we expect to see signing up. The four phrases that drive
 * persona recommendations ("real estate", "mortgage", "law firm",
 * "solo / independent") all appear here. Anything else still works — it
 * falls through to the default persona in mapOrgTypeToPersona.
 */
export const ORGANIZATION_TYPE_SUGGESTIONS: ReadonlyArray<string> = [
  'Real estate brokerage',
  'Real estate investor',
  'Property management',
  'Real estate developer',
  'Title / escrow',
  'Commercial real estate',
  'Mortgage / lending',
  'Law firm',
  'Accounting / tax',
  'Bookkeeping',
  'Financial advisor / wealth management',
  'Insurance agency',
  'Bank / credit union',
  'Consulting firm',
  'Solo / independent',
  'Marketing / advertising agency',
  'Design / creative agency',
  'Software / SaaS',
  'IT services / managed services',
  'Architecture firm',
  'Engineering firm',
  'Construction / general contracting',
  'HVAC / plumbing / electrical',
  'Landscaping',
  'Cleaning services',
  'Auto repair / dealership',
  'Logistics / shipping',
  'Manufacturing',
  'Wholesale / distribution',
  'E-commerce',
  'Retail store',
  'Restaurant / food service',
  'Cafe / bakery',
  'Hotel / hospitality',
  'Salon / barber / spa',
  'Fitness / gym',
  'Medical practice',
  'Dental practice',
  'Veterinary clinic',
  'Education / tutoring',
];

/**
 * Stored in `orgs.type` and `WelcomeAnalyzerQuestionnaire.firmType`. Kept as
 * a string alias (rather than a string literal union) because users can now
 * type any industry into the questionnaire.
 */
export type OrganizationType = string;

export const ORGANIZATION_TYPE_MAX_LENGTH = 200;
